function initBpmnXmlStr(tmpl) {
  return (
    `<?xml version="1.0" encoding="UTF-8"?>
  <definitions xmlns="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" xmlns:omgdc="http://www.omg.org/spec/DD/20100524/DC" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" id="sid-38422fae-e03e-43a3-bef4-bd33b32041b2" targetNamespace="http://bpmn.io/bpmn" exporter="bpmn-js (https://demo.bpmn.io)" exporterVersion="5.1.2">
    <process id="` +
    tmpl.tmplKey +
    `" name="` +
    tmpl.tmplName +
    `" isExecutable="true"> 
      <startEvent id="StartEvent_1y45yut" name="开始" />
    </process>
    <bpmndi:BPMNDiagram id="BpmnDiagram_1">
      <bpmndi:BPMNPlane id="BpmnPlane_1" bpmnElement="Process_1">
        <bpmndi:BPMNShape id="StartEvent_1y45yut_di" bpmnElement="StartEvent_1y45yut">
          <omgdc:Bounds x="162" y="172" width="36" height="36" />
          <bpmndi:BPMNLabel>
            <omgdc:Bounds x="170" y="215" width="22" height="14" />
          </bpmndi:BPMNLabel>
        </bpmndi:BPMNShape>
      </bpmndi:BPMNPlane>
    </bpmndi:BPMNDiagram>
  </definitions>`
  );
}

const initBpmnSvgStr = `<?xml version="1.0" encoding="utf-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- created with bpmn-js / http://bpmn.io -->
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48" height="69" viewBox="156 166 48 69" version="1.1">
  <defs>
    <marker id="sequenceflow-end-white-black-3bqki23hx872pfouqqld0hgkt" viewBox="0 0 20 20" 
    refX="11" refY="10" markerWidth="10" markerHeight="10" orient="auto">
      <path d="M 1 5 L 11 10 L 1 15 Z" style="fill: black; stroke-width: 1px; stroke-linecap: round; stroke-dasharray: 10000, 1; stroke: black;"/>
    </marker>
  </defs>
  <g class="djs-group">
    <g class="djs-element djs-shape djs-dragging" data-element-id="StartEvent_1y45yut" style="display: block;" transform="matrix(1 0 0 1 162 172)">
      <g class="djs-visual">
        <circle cx="18" cy="18" r="18" style="stroke: black; stroke-width: 2px; fill: white; fill-opacity: 0.95;"/>
      </g>
      <rect class="djs-hit djs-hit-all" x="0" y="0" width="36" height="36" style="fill: none; stroke-opacity: 0; stroke: white; stroke-width: 15px;"/>
      <rect x="-6" y="-6" width="48" height="48" class="djs-outline" style="fill: none;"/>
    </g>
  </g>
  <g class="djs-group">
    <g class="djs-element djs-shape djs-dragging" 
      data-element-id="StartEvent_1y45yut_label" style="display: block;" transform="matrix(1 0 0 1 170 215)">
      <g class="djs-visual">
        <text lineHeight="1.2" class="djs-label" style="font-family: Arial, sans-serif; font-size: 11px; font-weight: normal; fill: black;">
          <tspan x="0" y="9.899999999999999">开始</tspan>
        </text>
      </g>
      <rect class="djs-hit djs-hit-all" x="0" y="0" width="22" height="14" style="fill: none; stroke-opacity: 0; stroke: white; stroke-width: 15px;"/>
      <rect x="-6" y="-6" width="34" height="26" class="djs-outline" style="fill: none;"/>
    </g>
  </g>
  <g class="djs-drag-group" style="pointer-events: none;" transform="matrix(1 0 0 1 -40 0)">
    <g class="djs-dragger" data-element-id="StartEvent_1y45yut" style="display: block;" transform="matrix(1 0 0 1 202 172)" x="220" y="196">
      <g class="djs-visual">
        <circle cx="18" cy="18" r="18" style="stroke: black; stroke-width: 2px; fill: white; fill-opacity: 0.95;"/>
      </g>
      <rect class="djs-hit djs-hit-all" x="0" y="0" width="36" height="36" style="fill: none; stroke-opacity: 0; stroke: white; stroke-width: 15px;"/>
      <rect x="-6" y="-6" width="48" height="48" class="djs-outline" style="fill: none;"/>
    </g>
    <g class="djs-dragger" data-element-id="StartEvent_1y45yut_label" style="display: block;" transform="matrix(1 0 0 1 210 215)" x="263" y="204">
      <g class="djs-visual">
        <text lineHeight="1.2" class="djs-label" style="font-family: Arial, sans-serif; font-size: 11px; font-weight: normal; fill: black;">
          <tspan x="0" y="9.899999999999999">开始</tspan>
        </text>
      </g>
      <rect class="djs-hit djs-hit-all" x="0" y="0" width="22" height="14" style="fill: none; stroke-opacity: 0; stroke: white; stroke-width: 15px;"/>
      <rect x="-6" y="-6" width="34" height="26" class="djs-outline" style="fill: none;"/>
    </g>
  </g>
</svg>`;

export { initBpmnXmlStr, initBpmnSvgStr };
